<template>
  <v-app>
    <div class="main-content bg-white pb-20">
      <appbar-view></appbar-view>

      <br /><br />
      <div v-if="metodo !== 'efectivo'">
  <div class="direcciones-container p-4 bg-gray-50 rounded-lg shadow mb-6">
        <h3 class="font-bold text-lg mb-3">Mis direcciones</h3>

        <div v-if="isLoading" class="text-gray-500">Cargando direcciones...</div>
        <div v-else-if="direcciones.length === 0" class="text-gray-500">
          No se encontraron direcciones.
        </div>

        <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div
            v-for="(direccion, index) in direcciones"
            :key="direccion.CTEDIR_CODIGO_K || index"
            @click="direccion.CTEDIR_TIPOENT === '1' && seleccionarDireccion(direccion)"
            :class="[
              'p-3 rounded-lg border transition-all hover:shadow-md',
              direccion.CTEDIR_TIPOFIS === '1'
                ? 'bg-gray-200 border-gray-400 cursor-not-allowed opacity-70' // fiscal bloqueada
                : direccionSeleccionada &&
                  direccion.CTEDIR_CODIGO_K === direccionSeleccionada.CTEDIR_CODIGO_K
                ? 'bg-green-100 border-green-400 cursor-pointer'
                : 'bg-white border-gray-200 cursor-pointer',
            ]"
          >
            <p class="text-gray-800 text-sm font-semibold mb-1">
              {{ direccion.CTEDIR_CODIGO_K }}
            </p>
            <p class="text-gray-800 text-sm font-semibold mb-1">
              {{ direccion.CTECLI_DENCOMERCIA }}
            </p>
            <p class="text-gray-700 text-xs mb-1">
              {{ direccion.CTEDIR_CALLE }} Ext. {{ direccion.CTEDIR_CALLENUMEXT || "-" }},
              Int. {{ direccion.CTEDIR_CALLENUMINT || "-" }}
            </p>
            <p class="text-gray-700 text-xs mb-1">
              {{ direccion.CTEDIR_COLONIA }}, CP {{ direccion.CTEDIR_CP }}
            </p>
            <p class="text-gray-700 text-xs">
              Entre: {{ direccion.CTEDIR_CALLEENTRE1 }} y
              {{ direccion.CTEDIR_CALLEENTRE2 }}
            </p>
            <p v-if="direccion.CTEDIR_TIPOFIS === '1'" class="text-xs text-gray-500 mt-1">
              (Direccion predeterminada fiscal y/entrega)
            </p>
          </div>
        </div>
      </div>

      </div>
    

      <div
        class="max-w-md mx-auto p-4 border border-gray-200 rounded-xl shadow-lg mb-6 space-y-4"
      >
        <div class="flex items-center space-x-3">
          <img
            src="https://mvexpress.mx/images/mvsimple.png"
            alt="MV Coins"
            class="w-10 h-10 rounded-full border border-gray-300"
          />

          <label class="flex items-center cursor-pointer">
            <div class="relative">
              <input
                type="checkbox"
                v-model="useMvCoins"
                @change="calculateTotal"
                class="sr-only"
              />
              <div
                class="w-12 h-6 rounded-full shadow-inner transition-colors duration-300"
                :class="useMvCoins ? 'bg-green-500' : 'bg-gray-300'"
              ></div>
              <div
                class="dot absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300"
                :class="useMvCoins ? 'translate-x-6' : 'translate-x-0'"
              ></div>
            </div>
            <span class="ml-3 text-gray-700 font-medium">Usar MV Coins</span>
          </label>
        </div>

        <!-- Cantidad de MV Coins a usar -->
        <transition name="slide-y" appear>
          <div v-if="useMvCoins">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Cantidad de MV Coins a usar
            </label>
            <input
              type="number"
              v-model.number="mvCoinsToUse"
              @input="onMvCoinsChange"
              :max="user.mvCoins"
              :min="0"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="0"
            />
            <p class="mt-1 text-xs text-gray-500">
              Usando: {{ mvCoinsToUse }} / {{ user.mvCoins }} MV Coins
            </p>
          </div>
        </transition>

        <!-- Total después de MV Coins -->
        <div
          v-if="useMvCoins"
          class="flex justify-between items-center p-4 bg-orange-50 border border-gray-200 rounded-xl"
        >
          <span class="text-gray-700 font-semibold">Total después de MV Coins:</span>
          <div class="flex items-baseline space-x-1">
            <span class="text-2xl font-bold text-orange-600">{{
              totalFinalCalculado.toFixed(2)
            }}</span>
            <span class="text-sm font-medium text-gray-500">MXN</span>
          </div>
        </div>
      </div>

      <!-- 🔹 Selección de método de pago -->
      <!-- 🔹 Selección de método de pago -->
      <div class="max-w-md mx-auto p-4 space-y-4">
        <h2 class="text-xl font-semibold text-center mb-2">
          Selecciona un método de pago
        </h2>

        <div class="grid grid-cols-2 gap-4">
          <!-- Toggle Tarjeta -->
      <div
  :class="['border-2 rounded-lg p-4 flex flex-col items-center justify-center transition-all', disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer hover:bg-indigo-50']"
  @click="!disabled && abrirPagoOpenPay()"
>
  <v-icon size="36" color="indigo">mdi-credit-card</v-icon>
  <p class="font-medium mt-2">Tarjeta (OpenPay)</p>
</div>


          <!-- Toggle Efectivo -->
          <div
            class="border-2 rounded-lg p-4 cursor-pointer text-center select-none transition-all flex flex-col items-center justify-center"
            @click="metodo = 'efectivo'"
            :class="
              metodo === 'efectivo' ? 'border-green-500 bg-green-100' : 'border-gray-300'
            "
          >
            <v-icon size="36" color="green darken-2">mdi-cash</v-icon>
            <p class="font-medium mt-2">Efectivo al recibir</p>
          </div>
        </div>

        <!-- Botón continuar -->
<!-- NUEVO BOTÓN SIN DESLIZAR -->
<div v-if="metodo" class="mt-6 mx-auto w-[90%] max-w-xs">

  <!-- Checkbox de confirmación -->
  <label class="flex items-center mb-3 cursor-pointer">
    <input 
      type="checkbox" 
      v-model="confirmarPedido" 
      class="mr-2"
    />
    <span class="text-sm text-gray-700">
      Este pedido será pagado al recibir tus productos
    </span>
  </label>

  <!-- BOTÓN -->
  <button
    :disabled="!confirmarPedido"
    @click="continuarPago"
    class="w-full py-3 text-white font-semibold rounded-lg transition-all"
    :class="confirmarPedido ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-400 cursor-not-allowed'"
  >
    {{ metodo === 'openpay' ? 'Pagar ahora 💳' : 'Confirmar pedido 💵' }}
  </button>
</div>

      </div>

      <!-- 🔹 Modal de pago con OpenPay -->

      <!-- 🔹 MODAL FORMULARIO DE TARJETA OPENPAY -->
      <div
        v-if="showFormOpenPay"
        class="fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white p-6 rounded-lg w-96 shadow-lg relative animate-fade-in">
          <!-- Botón de cierre (esquina superior derecha) -->
          <button
            @click="cancelarPagoOpenPay"
            class="absolute top-2 right-2 text-gray-500 hover:text-red-500"
            title="Cerrar"
          >
            ✕
          </button>

          <h2 class="text-xl font-bold mb-4 text-center">Pago con tarjeta</h2>

          <form id="payment-form" @submit.prevent="confirmPaymentOpenPay">
            <div class="mb-2">
              <label class="block text-sm">Número de tarjeta</label>
              <input
                type="text"
                data-openpay-card="card_number"
                v-model="card.card_number"
                placeholder="4111111111111111"
                class="border p-2 w-full rounded"
                required
              />
            </div>

            <div class="mb-2">
              <label class="block text-sm">Nombre en tarjeta</label>
              <input
                type="text"
                data-openpay-card="holder_name"
                v-model="card.holder_name"
                placeholder="Juan Pérez"
                class="border p-2 w-full rounded"
                required
              />
            </div>

            <div class="flex space-x-2 mb-2">
              <div class="w-1/2">
                <label class="block text-sm">Mes (MM)</label>
                <input
                  type="text"
                  data-openpay-card="expiration_month"
                  v-model="card.expiration_month"
                  placeholder="MM"
                  maxlength="2"
                  class="border p-2 w-full rounded"
                  required
                />
              </div>
              <div class="w-1/2">
                <label class="block text-sm">Año (AA)</label>
                <input
                  type="text"
                  data-openpay-card="expiration_year"
                  v-model="card.expiration_year"
                  placeholder="AA"
                  maxlength="2"
                  class="border p-2 w-full rounded"
                  required
                />
              </div>
            </div>

            <div class="mb-2">
              <label class="block text-sm">CVV</label>
              <input
                type="text"
                data-openpay-card="cvv2"
                v-model="card.cvv2"
                placeholder="123"
                maxlength="4"
                class="border p-2 w-full rounded"
                required
              />
            </div>

            <p class="mt-3 font-semibold text-center">
              💳 Total a pagar:
              <span class="text-green-600">${{ totalFinalCalculado.toFixed(2) }}</span>
            </p>

            <button
              type="submit"
              class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded mt-3 w-full"
            >
              Confirmar pago
            </button>

            <button
              type="button"
              @click="cancelarPagoOpenPay"
              class="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded mt-2 w-full"
            >
              Cancelar
            </button>
          </form>
        </div>
      </div>
      <!-- 🔹 Uso de MV Coins -->

      <!-- ... resto de tu UI ... -->
      <bottom-navigation class="fixed-bottom-nav" />
    </div>
  </v-app>
</template>

<script>
/* global OpenPay */
import axios from "axios";
import Swal from "sweetalert2";
import appbarView from "./appbar/appbarView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";
import { useUserStore } from "@/stores/userStore"; // ✅ importa el store

export default {
  setup() {},
  components: { appbarView, BottomNavigation },
  data() {
    return {
      confirmarPedido: false,
      snackbar: {
        show: false,
        message: "",
        color: "green", // 'success', 'error', 'warning', 'info'
      },
      userStore: useUserStore(),
      swipeStartXContinuar: 0,
      swipeWidthContinuar: 0,
      swipeDoneContinuar: false,
      metodo: "",
    disabled: true, // cambia a false para habilitar

      userData: {},
      direcciones: [], // <--- inicializado vacío
      isLoading: false,
      // estado existente
      carrito: JSON.parse(localStorage.getItem("cart")) || [],
      roundedTotal: parseFloat(localStorage.getItem("checkoutTotal")) || 0,
      user: JSON.parse(localStorage.getItem("user")) || { mvCoins: 0 },
      mvCoinsToUse: 0,
      useMvCoins: false,
      direccionSeleccionada:
        JSON.parse(localStorage.getItem("direccionSeleccionada")) || null,

      // OpenPay modal & tarjeta
      showFormOpenPay: false,
      deviceSessionId: null,
      card: {
        holder_name: "",
        card_number: "",
        expiration_month: "",
        expiration_year: "",
        cvv2: "",
      },
    };
  },
  computed: {
    // <-- método que pediste (totalFinalCalculado)
    totalFinalCalculado() {
      const total = this.roundedTotal || 0;
      const mvCoins = this.useMvCoins ? parseFloat(this.mvCoinsToUse) || 0 : 0;
      const coinsToApply = Math.min(mvCoins, this.user.mvCoins || 0, total);
      return total - coinsToApply;
    },
  },

  mounted() {
    this.loadCartData();
    if (!this.direcciones.length) {
      this.obtenerDirecciones();
    }
    this.calculateCartTotal();
    this.verificarPolitica();

    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      this.user = JSON.parse(storedUser);

      if (this.user.direcciones?.length) {
        // Función para normalizar string (minúscula y sin acentos)
        const normalize = (str) =>
          str
            .normalize("NFD") // separa los acentos
            .replace(/[\u0300-\u036f]/g, "") // quita acentos
            .toLowerCase()
            .trim();

        const diasSemana = [
          "DOMING",
          "LUNES",
          "MARTES",
          "MIERCOLES",
          "JUEVES",
          "VIERNES",
          "SABADO",
        ];
        const hoy = normalize(diasSemana[new Date().getDay()]);

        const dias = this.user.direcciones
          .map((d) => (normalize(d.dia) === hoy ? "HOY" : d.dia))
          .join(", ");

        this.showNotification(`Tus días de entrega es ${dias}`, "info");
      }
    }
  },

  methods: {
    showNotification(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    async verificarPolitica() {
      await this.userStore.obtenerNuevaData();
      if (!this.userStore.user?.politica_privacidad_aceptada) {
        alert("Debes aceptar el aviso de privacidad antes de continuar.");
        window.location.replace("/aviso-privacidad");
      }
    },
      continuarPago() {
        if (this.metodo === "openpay") {
          this.abrirPagoOpenPay();
        } else if (this.metodo === "efectivo") {
          this.confirmarPagoEfectivo();
        } else {
          Swal.fire("Selecciona un método de pago", "", "info");
        }
      },
    startSwipeContinuar(event) {
      this.swipeDoneContinuar = false;
      const e = event.type.includes("touch") ? event.touches[0] : event;
      this.swipeStartXContinuar = e.clientX;

      window.addEventListener("mousemove", this.onSwipeMoveContinuar);
      window.addEventListener("touchmove", this.onSwipeMoveContinuar);
      window.addEventListener("mouseup", this.endSwipeContinuar);
      window.addEventListener("touchend", this.endSwipeContinuar);
    },

    onSwipeMoveContinuar(event) {
      const e = event.type.includes("touch") ? event.touches[0] : event;
      const deltaX = e.clientX - this.swipeStartXContinuar;
      this.swipeWidthContinuar = Math.max(
        0,
        Math.min(deltaX, this.$refs.swipeContinuar.offsetWidth)
      );
    },

    endSwipeContinuar() {
      const ancho = this.$refs.swipeContinuar.offsetWidth;

      if (this.swipeWidthContinuar > ancho * 0.8) {
        this.swipeWidthContinuar = ancho;
        this.swipeDoneContinuar = true;

        // ✅ Lógica según método
        if (this.metodo === "efectivo") {
          this.confirmarPagoEfectivo();
        } else if (this.metodo === "openpay") {
          this.abrirPagoOpenPay();
        }
      } else {
        // ❌ No completó el swipe → reset
        this.swipeWidthContinuar = 0;
      }

      // Quitar listeners
      window.removeEventListener("mousemove", this.onSwipeMoveContinuar);
      window.removeEventListener("touchmove", this.onSwipeMoveContinuar);
      window.removeEventListener("mouseup", this.endSwipeContinuar);
      window.removeEventListener("touchend", this.endSwipeContinuar);
    },

    async obtenerDirecciones() {
      console.log("🔹 obtenerDirecciones() iniciado");
      this.isLoading = true;
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        console.log("Usuario desde localStorage:", user);

        if (!user || !user.cliente) {
          console.error("Usuario no encontrado en localStorage");
          return;
        }

        const cacheKey = `direcciones_${user.cliente}`;
        const cacheTimeKey = `${cacheKey}_timestamp`;
        const now = Date.now();
        const oneWeek = 1 * 60 * 1000; // 1 semana en ms (puedes ajustar)

        const cachedData = localStorage.getItem(cacheKey);
        const cachedTime = localStorage.getItem(cacheTimeKey);
        console.log("cachedData:", cachedData, "cachedTime:", cachedTime);

        if (cachedData && cachedTime && now - cachedTime < oneWeek) {
          this.direcciones = JSON.parse(cachedData);
          console.log("Direcciones desde cache:", this.direcciones);
          return;
        }

        console.log("Consultando API de direcciones...");
        const response = await axios.get(
          `https://mvexpress.mx/api/find-direccion/${user.cliente}`
        );
        this.direcciones = response.data.filter(
          (dir, index, self) =>
            index === self.findIndex((d) => d.CTEDIR_CODIGO_K === dir.CTEDIR_CODIGO_K)
        );
        // Guardar en localStorage si no es muy pesado
        try {
          const jsonData = JSON.stringify(response.data);
          if (jsonData.length < 4 * 1024 * 1024) {
            localStorage.setItem(cacheKey, jsonData);
            localStorage.setItem(cacheTimeKey, now);
            console.log("Direcciones guardadas en localStorage");
          } else {
            console.warn("Respuesta muy grande, no se guardará en localStorage.");
          }
        } catch (e) {
          console.warn("No se pudo guardar en localStorage:", e.message);
        }
      } catch (error) {
        console.error("Error al obtener las direcciones:", error);
        this.errorMessage = error.response
          ? `Error ${error.response.status}: ${error.response.data.message}`
          : "No se pudo conectar con el servidor.";
      } finally {
        this.isLoading = false;
        console.log("🔹 obtenerDirecciones() finalizado, isLoading:", this.isLoading);
      }
    },

    seleccionarDireccion(direccion) {
      console.log("Dirección seleccionada:", direccion);
      this.direccionSeleccionada = direccion;
      localStorage.setItem("direccionSeleccionada", JSON.stringify(direccion));
    },
    // Cargar los datos del carrito desde el localStorage
    async loadCartData() {
      this.carrito = JSON.parse(localStorage.getItem("cart")) || [];
      this.calculateCartTotal(); // Calcular el total después de cargar el carrito
    },

    async confirmarPagoEfectivo() {
      try {
        if (!this.carrito || this.carrito.length === 0) {
          Swal.fire("Carrito vacío", "Agrega productos antes de pagar.", "warning");
          return;
        }

        const user = JSON.parse(localStorage.getItem("user")) || {};

        const productos = this.carrito.map((item) => ({
          id: item.id || item.producto_id,
          nombre: item.nombre || item.name || "Producto sin nombre",
          cantidad: item.quantity || 1,
          precio: parseFloat(
            item.promo_price ||
              item.precio_con_descuento ||
              item.precio_desc ||
              item.price ||
              0
          ),
        }));

        // 🔹 Tomar direcciones del cache siempre que exista
        const cachedData = localStorage.getItem(`direcciones_${user.cliente}`);
        const direccionesCache = cachedData ? JSON.parse(cachedData) : [];

        // Separar fiscal y entrega
        const direccionFiscal =
          direccionesCache.find((d) => d.CTEDIR_TIPOFIS === "1") || {};
        const direccionEntrega =
          direccionesCache.find((d) => d.CTEDIR_TIPOENT === "1") || {};

        const datosPedido = {
          cliente_id: user.cliente || null,
          productos,
          total: this.totalFinalCalculado,
          metodo_pago: "efectivo",
          CTEDIR_CODIGO_K: direccionFiscal.CTEDIR_CODIGO_K || "1", // fallback a "1" si no hay nada
          CTEDIR_CODIGO_ENT: direccionEntrega.CTEDIR_CODIGO_K || "1", // fallback a "1" si no hay nada
          mvCoinsToUse: this.mvCoinsToUse || 0,
          udnCliente: user.udn || null,
          email: user.email || null,
          observaciones: "Pago en efectivo por cobrar al repartidor",
        };

        console.log("📦 Enviando pedido efectivo:", datosPedido);

        const urlBackend = "https://mvexpress.mx/api/crear-sesion-efectivo";
        const resp = await axios.post(urlBackend, datosPedido, {
          headers: { "Content-Type": "application/json" },
        });

        if (resp.data && resp.data.status === "completed") {
          Swal.fire(
            "Pedido creado",
            "Tu pedido fue registrado. Paga al repartidor al recibirlo.",
            "success"
          );
          localStorage.removeItem("cart");
          this.carrito = [];
          this.$router.push("/SucessView");
        } else {
          Swal.fire(
            "Error",
            resp.data.message || "No se pudo crear el pedido en efectivo.",
            "error"
          );
        }
      } catch (err) {
        console.error("Error en confirmarPagoEfectivo:", err);
        Swal.fire(
          "Error",
          err.message || "Ocurrió un error al procesar el pedido en efectivo.",
          "error"
        );
      }
    },

    // utilitarios de carrito (ya existentes en tu proyecto pero por si acaso)
    calculateCartTotal(productos = this.carrito) {
      this.roundedTotal = parseFloat(
        productos
          .reduce((sum, item) => {
            const precio = parseFloat(
              item.promo_price ||
                item.precio_con_descuento ||
                item.precio_desc ||
                item.price ||
                0
            );
            return sum + precio * (item.quantity || 1);
          }, 0)
          .toFixed(2)
      );
    },

    validateMvCoins() {
      if (this.mvCoinsToUse < 0) this.mvCoinsToUse = 0;
      if (this.mvCoinsToUse > (this.user.mvCoins || 0))
        this.mvCoinsToUse = this.user.mvCoins || 0;
    },

    onMvCoinsChange() {
      this.validateMvCoins();
    },

    // ----- OpenPay: abrir / cancelar modal -----
    abrirPagoOpenPay() {
      // Configura OpenPay (usa tus keys de sandbox o producción)
      OpenPay.setId("mrhcqairad7fcz7e5v4s"); // reemplaza con tu merchant id
      OpenPay.setApiKey("pk_e75ad998669a4dff984f734d13d46653"); // reemplaza con tu public key
      OpenPay.setSandboxMode(true);

      // genera device_session_id (lo asigna en input hidden con name device_session_id si existe)
      // también devuelve el id para enviarlo manualmente
      try {
        this.deviceSessionId = OpenPay.deviceData.setup(
          "payment-form",
          "device_session_id"
        );
        console.log("deviceSessionId generado:", this.deviceSessionId);
      } catch (err) {
        console.warn(
          "deviceData.setup error (si no existe input hidden está bien):",
          err
        );
      }

      this.showFormOpenPay = true;
    },

    cancelarPagoOpenPay() {
      this.showFormOpenPay = false;
      // limpiar datos sensibles
      this.card = {
        holder_name: "",
        card_number: "",
        expiration_month: "",
        expiration_year: "",
        cvv2: "",
      };
      this.deviceSessionId = null;
    },

    async obtenerNuevaData() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) {
          console.error("Usuario no encontrado en localStorage");
          return;
        }

        const response = await axios.get(
          `https://mvexpress.mx/api/get-mvcoins/${user.id}`
        );

        this.userData = response.data;
        // Actualiza el usuario en localStorage
        //  alert("Datos del usuario actualizados"+ JSON.stringify(this.userData));
        // Actualiza el usuario en el estado del componente
        this.user = this.userData;
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    },

    // ----- Crear token y enviar pedido al backend -----
    async confirmPaymentOpenPay() {
      try {
        // Validaciones mínimas
        if (!this.carrito || this.carrito.length === 0) {
          Swal.fire("Carrito vacío", "Agrega productos antes de pagar.", "warning");
          return;
        }

        // Formatear mes/año a 2 dígitos (OpenPay exige month=2 chars, year=2 chars)
        this.card.expiration_month = String(this.card.expiration_month || "")
          .padStart(2, "0")
          .slice(-2);
        this.card.expiration_year = String(this.card.expiration_year || "")
          .padStart(2, "0")
          .slice(-2);

        // Crear token (usando OpenPay.token.create con cardData)
        const cardData = {
          holder_name: this.card.holder_name,
          card_number: this.card.card_number,
          expiration_month: this.card.expiration_month,
          expiration_year: this.card.expiration_year,
          cvv2: this.card.cvv2,
        };

        console.log("Solicitando token OpenPay con:", cardData);

        const tokenResp = await new Promise((resolve, reject) => {
          OpenPay.token.create(
            cardData,
            (response) => resolve(response),
            (error) => reject(error)
          );
        });

        console.log("Token OpenPay recibido:", tokenResp);

        if (!tokenResp || !tokenResp.data || !tokenResp.data.id) {
          throw new Error("No se generó token de OpenPay.");
        }

        const token_id = tokenResp.data.id;
        // Si deviceSessionId no está, intenta obtenerlo nuevamente (por seguridad)
        if (!this.deviceSessionId) {
          try {
            this.deviceSessionId = OpenPay.deviceData.setup(
              "payment-form",
              "device_session_id"
            );
            console.log("deviceSessionId regenerado:", this.deviceSessionId);
          } catch (e) {
            console.warn("No se pudo regenerar deviceSessionId:", e);
          }
        }

        // Prepara datos del pedido (usa el total calculado por computed)
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const productos = this.carrito.map((item) => ({
          id: item.id || item.producto_id,
          nombre: item.nombre || item.name || "Producto sin nombre",
          cantidad: item.quantity || 1,
          precio: parseFloat(
            item.promo_price ||
              item.precio_con_descuento ||
              item.precio_desc ||
              item.price ||
              0
          ),
        }));

        const datosPedido = {
          cliente_id: user.cliente || null,
          productos,
          total: this.totalFinalCalculado,
          metodo_pago: "card",
          token_id,
          device_session_id: this.deviceSessionId,
          CTEDIR_CODIGO_K: this.direccionSeleccionada?.CTEDIR_CODIGO_K || null,
          mvCoinsToUse: this.mvCoinsToUse || 0,
          email: user.email || null, // <-- aquí agregamos el email

          udnCliente: user.udn || null,
        };

        console.log("Enviando al backend (crear-sesion-openpay):", datosPedido);

        // Llamada al backend (cambia la URL si necesario)
        const urlBackend = "https://mvexpress.mx/api/crear-sesion-openpay";
        const resp = await axios.post(urlBackend, datosPedido, {
          headers: { "Content-Type": "application/json" },
        });

        console.log("Respuesta backend OpenPay:", resp.data);

        // Manejo de respuesta
        const backendData = resp.data || {};
        if (
          backendData.status === "completed" ||
          backendData.charge_status === "completed"
        ) {
          Swal.fire("Pago exitoso", "Tu pago fue procesado correctamente.", "success");
          localStorage.removeItem("cart");
          this.carrito = [];
          this.cancelarPagoOpenPay();
          this.$router.push("/SucessView");
          return;
        }

        if (
          backendData.status === "pending" ||
          backendData.charge_status === "pending" ||
          backendData.charge_status === "in_progress"
        ) {
          Swal.fire(
            "Pago pendiente",
            "Tu pago está en proceso o requiere confirmación.",
            "info"
          );
          this.cancelarPagoOpenPay();
          return;
        }

        // Si llega aquí, error genérico
        Swal.fire(
          "Error",
          backendData.message || "No se pudo completar el pago.",
          "error"
        );
        this.cancelarPagoOpenPay();
      } catch (err) {
        // OpenPay puede devolver objeto con data.description
        console.error("Error en confirmPaymentOpenPay:", err);
        const msg =
          err?.data?.description ||
          err?.response?.data?.error?.description ||
          err.message ||
          "Error al procesar el pago.";
        Swal.fire("Error", msg, "error");
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-bottom: 80px;
  background-color: #ffffff;
}
div[ref="swipeButton"] {
  user-select: none;
}
</style>
